import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/services/auth.service';
import { BillersService } from 'src/app/services/billers.service';
import { CommonService } from 'src/app/services/common.service';
import { SendMoneyService } from '../send-money/send-money.service';

@Component({
  selector: 'app-celo-send-successful',
  templateUrl: './celo-send-successful.component.html',
  styleUrls: ['./celo-send-successful.component.scss']
})
export class CeloSendSuccessfulComponent implements OnInit {

  trans_key = ""
  payment_id =""
  celo_to_address = ""


  @Input() public amount;
  celo_wallet_number: number = 0;

  constructor(public activatedRoute: ActivatedRoute, private messageService: MessageService, public common: CommonService, public sendMoneyService: SendMoneyService, private auth: AuthService, public billerService: BillersService) { }

  ngOnInit(): void {

    //console.log("velo-page-paynt",this.sendMoneyService.paymentdetails);
  
     console.log(this.billerService.finalData,
       "celo-response-biller")
    this.common.stopLoader()
    this.trans_key = this.activatedRoute.snapshot.paramMap.get("trans_key")
    this.payment_id = this.sendMoneyService.paymentdetails.payment_id || this.billerService.finalData['payment_id'];
    this.celo_to_address = this.sendMoneyService.paymentdetails.celo_to_address || this.billerService.finalData['celo_to_address'];
   
    this.amount = this.sendMoneyService.transactionDetails?.celo_total_amount || this.billerService.finalData['celoAmount'];
    this.celo_wallet_number = this.sendMoneyService.transactionDetails?.celoWalletNumber || this.billerService.finalData['celoNumber'];
    this.amount = (+this.amount).toFixed(2)
    if (this.sendMoneyService.transactionDetails?.coupon_id) {
      this.sendMoneyService.usedCoupon(this.sendMoneyService.transactionDetails.coupon_id, this.auth.user.id).subscribe(res => {
        //console.log(res)
      })
    }
  }


  copyMessage() {
    //console.log(this.trans_key)
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.trans_key;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.messageService.add({ severity: 'success', summary: 'Copied', detail: "" });
    //console.log("link copied!")
  }
}
